 /* eslint-disable max-lines */
 // tslint:disable-next-line:max-line-length
import { ACTION_TYPE } from '../../models/flow-management.model';
import { OrderDetailsActionTypes } from '../../redux/actions/order-details.action';
import { RoutingActionType } from 'src/app/redux/actions/routing.action';
import { CustomerSupportActionTypes } from 'src/app/redux/actions/customer-support.actions';
import { ABBREVIATION_TABLE } from '@vfde-fe/ngx-lib/core';
import { OverlayActionType } from 'src/app/redux/actions/overlay.action';
import { CustomerDetailsActionTypes } from 'src/app/redux/actions/customer-details.actions';

/** flowMangementConfig */
export const flowMangementConfig = {
    common: {
        'revocation-step-one': {
            steps: [
                {
                    type: ACTION_TYPE.REDUX_ACTION,
                    id: 'revocation-step-one-link1',
                    actionDetails: {
                        dispatchAction: CustomerSupportActionTypes.STORE_CALLBACK_LINK_IDENTIFER + ',' + CustomerSupportActionTypes.STORE_CUSTOMER_SUPPORT_MESSAGES + ',' + OrderDetailsActionTypes.SET_TRANSACTION_NAME + ',' + RoutingActionType.START_ROUTING,
                    },
                    wording: {
                        headLine: 'revocationModule.simHardware.hardwareSelection.process.externalLinks.deviceIsNotIncluded.std-headline',
                        subHeadLine: 'revocationModule.simHardware.hardwareSelection.process.externalLinks.deviceIsNotIncluded.text-body',
                        icon: 'revocationModule.simHardware.hardwareSelection.process.externalLinks.deviceIsNotIncluded.opt-icon',
                    },
                },
                {
                    type: ACTION_TYPE.REDUX_ACTION,
                    id: 'revocation-step-one-link2',
                    hideInPostalShopping: true,
                    actionDetails: {
                        dispatchAction: OrderDetailsActionTypes.RESET_POSITION + ',' + RoutingActionType.START_ROUTING,
                    },
                    wording: {
                        headLine: 'revocationModule.simHardware.hardwareSelection.process.externalLinks.deviceRevocation.std-headline',
                        subHeadLine: 'revocationModule.simHardware.hardwareSelection.process.externalLinks.deviceRevocation.text-body',
                        icon: 'revocationModule.simHardware.hardwareSelection.process.externalLinks.deviceRevocation.opt-icon',
                    },
                },
            ],
        },
        'winback-page': {
            steps: [{
                id: 'review-page',
                groupId: '1',
                type: ACTION_TYPE.REDUX_ACTION,
                actionDetails: {
                    dispatchAction: OrderDetailsActionTypes.RESET_POSITION + ',' + RoutingActionType.START_ROUTING,
                },
                wording: {
                    headLine: 'winbackModule.flowManagement.confirm.std-headline',
                    subHeadLine: 'winbackModule.flowManagement.confirm.std-subHeadline',
                    icon: 'common.commonLinks.reviewPage.opt-icon',
                },
            }],
        },
        'revocation-options': {
            steps: [
                {
                    id: 'revocation-step-one-link',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: RoutingActionType.START_ROUTING,
                    },
                    wording: {
                        headLine: 'common.links.simHardwareFirstStep.std-headline',
                        subHeadLine: 'common.links.simHardwareFirstStep.text-body',
                        icon: 'common.links.simHardwareFirstStep.opt-icon',
                    },
                },
                {
                    id: 'sales-agent-link',
                    type: ACTION_TYPE.REDUX_ACTION,
                    hideInPostalShopping: true,
                    actionDetails: {
                        dispatchAction: OrderDetailsActionTypes.SET_RETURN_REASON_CODE + ',' + OrderDetailsActionTypes.SET_TRANSACTION_NAME + ',' + OrderDetailsActionTypes.SET_FORWARD_TO_AGENT + ',' + OrderDetailsActionTypes.CHANGE_ORDER,
                    },
                    wording: {
                        headLine: 'common.links.salesAgent.std-headline',
                        subHeadLine: 'common.links.salesAgent.text-body',
                        icon: 'common.links.salesAgent.opt-icon',
                    },
                },
                {
                    id: 'open-questions-link',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: OrderDetailsActionTypes.SET_RETURN_REASON_CODE + ',' + OrderDetailsActionTypes.SET_TRANSACTION_NAME + ',' + OrderDetailsActionTypes.SET_FORWARD_TO_AGENT + ',' + RoutingActionType.START_ROUTING,
                    },
                    wording: {
                        headLine: 'common.links.openQuestions.std-headline',
                        subHeadLine: 'common.links.openQuestions.text-body',
                        icon: 'common.links.openQuestions.opt-icon',
                    },
                },
                {
                    id: 'marketing-one',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'common.links.marketingOne.isHidden.text-body',
                    wording: {
                        headLine: 'common.links.marketingOne.std-headline',
                        subHeadLine: 'common.links.marketingOne.std-subHeadline',
                        icon: 'common.links.marketingOne.opt-icon',
                    },
                },
                {
                    id: 'marketing-two',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'common.links.marketingTwo.isHidden.text-body',
                    wording: {
                        headLine: 'common.links.marketingTwo.std-headline',
                        subHeadLine: 'common.links.marketingTwo.std-subHeadline',
                        icon: 'common.links.marketingTwo.opt-icon',
                    },
                },
                {
                    id: 'marketing-three',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: OverlayActionType.TOGGLE_OVERLAY,
                    },
                    isHidden: 'common.links.marketingThree.isHidden.text-body',
                    wording: {
                        headLine: 'common.links.marketingThree.std-headline',
                        subHeadLine: 'common.links.marketingThree.std-subHeadline',
                        icon: 'common.links.marketingThree.opt-icon',
                    },
                },
                {
                    id: 'winback-link',
                    type: ACTION_TYPE.REDUX_ACTION,
                    hideInPostalShopping: true,
                    actionDetails: {
                        dispatchAction: OrderDetailsActionTypes.SET_RETURN_REASON_CODE + ',' + OrderDetailsActionTypes.SET_TRANSACTION_NAME + ',' + RoutingActionType.START_ROUTING,

                    },
                    wording: {
                        headLine: 'common.links.winbackPage.std-headline',
                        subHeadLine: 'common.links.winbackPage.text-body',
                        icon: 'common.links.winbackPage.opt-icon',
                    },
                },
            ],
        },
        'open-questions-page': {
            steps: [
                {
                id: 'Vodafone-HS',
                groupId: '1',
                type: ACTION_TYPE.REDUX_ACTION,
                actionDetails: {
                    dispatchAction: OrderDetailsActionTypes.REMOVE_BEFORE_UNLOAD_LISTENER + ',' + OrderDetailsActionTypes.SET_FORWARD_TO_AGENT
                    + ',' + OrderDetailsActionTypes.CHANGE_ORDER + ',' + OrderDetailsActionTypes.REMOVE_FORWARD_TO_AGENT,
                },
                wording: {
                    headLine: 'openQuestionsModule.helpLink.std-headline',
                    subHeadLine: 'openQuestionsModule.helpLink.std-subHeadline',
                    icon: 'common.commonLinks.openQuestion.opt-icon',
                },
            },
            {
                id: 'chat-link-id',
                groupId: '2',
                type: ACTION_TYPE.REDUX_ACTION,
                actionDetails: {
                    dispatchAction: CustomerSupportActionTypes.STORE_CUSTOMER_SUPPORT_MESSAGES + ',' + OrderDetailsActionTypes.SET_FORWARD_TO_AGENT + ',' + OrderDetailsActionTypes.CHANGE_ORDER
                    + ',' + OrderDetailsActionTypes.REMOVE_FORWARD_TO_AGENT,
                },
                wording: {
                    headLine: 'openQuestionsModule.chatLink.std-headline',
                    subHeadLine: 'openQuestionsModule.chatLink.std-subHeadline',
                    icon: 'common.commonLinks.chat.opt-icon',
                },
            },
            {
                id: 'cancel-contract',
                hideInPostalShopping: true,
                type: ACTION_TYPE.REDUX_ACTION,
                groupId: '3',
                actionDetails: {
                    dispatchAction:  CustomerSupportActionTypes.CUSTOMER_SUPPORT_CONTRACT_CANCELLATION,
                },
                wording: {
                    headLine: 'openQuestionsModule.cancelContract.std-headline',
                    subHeadLine: 'openQuestionsModule.cancelContract.text-body',
                    icon: 'common.commonLinks.reviewPage.opt-icon',
                },
            }],
        },
        'sim-revocation-options': {
            steps: [
                {
                    id: 'link-for-winback',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: OrderDetailsActionTypes.SET_RETURN_REASON_CODE + ',' + OrderDetailsActionTypes.SET_TRANSACTION_NAME + ',' + OrderDetailsActionTypes.SET_FORWARD_TO_AGENT + ',' + OrderDetailsActionTypes.CHANGE_ORDER,
                    },
                    wording: {
                        headLine: 'common.links.salesAgent.std-headline',
                        subHeadLine: 'common.links.salesAgent.text-body',
                        icon: 'common.links.salesAgent.opt-icon',
                    },
                },
                {
                    id: 'open-questions-link',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: OrderDetailsActionTypes.SET_RETURN_REASON_CODE + ',' + OrderDetailsActionTypes.SET_TRANSACTION_NAME + ',' + RoutingActionType.START_ROUTING,
                    },
                    wording: {
                        headLine: 'common.links.openQuestions.std-headline',
                        subHeadLine: 'common.links.openQuestions.text-body',
                        icon: 'common.links.openQuestions.opt-icon',
                    },
                },
                {
                    id: 'marketing-one',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'common.links.marketingOne.isHidden.text-body',
                    wording: {
                        headLine: 'common.links.marketingOne.std-headline',
                        subHeadLine: 'common.links.marketingOne.std-subHeadline',
                        icon: 'common.links.marketingOne.opt-icon',
                    },
                },
                {
                    id: 'marketing-two',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'common.links.marketingTwo.isHidden.text-body',
                    wording: {
                        headLine: 'common.links.marketingTwo.std-headline',
                        subHeadLine: 'common.links.marketingTwo.std-subHeadline',
                        icon: 'common.links.marketingTwo.opt-icon',
                    },
                },
                {
                    id: 'marketing-three',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: OverlayActionType.TOGGLE_OVERLAY,
                    },
                    isHidden: 'common.links.marketingThree.isHidden.text-body',
                    wording: {
                        headLine: 'common.links.marketingThree.std-headline',
                        subHeadLine: 'common.links.marketingThree.std-subHeadline',
                        icon: 'common.links.marketingThree.opt-icon',
                    },
                },
                {
                    id: 'winback-link',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: OrderDetailsActionTypes.SET_RETURN_REASON_CODE + ',' + OrderDetailsActionTypes.SET_TRANSACTION_NAME + ',' + RoutingActionType.START_ROUTING,
                    },
                    wording: {
                        headLine: 'common.links.winbackPage.std-headline',
                        subHeadLine: 'common.links.winbackPage.text-body',
                        icon: 'common.links.winbackPage.opt-icon',
                    },
                },
            ],
        },
        'consultant-chooser': {
            steps: [{
                id: 'chat-link',
                groupId: '1',
                type: ACTION_TYPE.REDUX_ACTION,
                actionDetails: {
                    dispatchAction: OrderDetailsActionTypes.SET_FORWARD_TO_AGENT + ',' + OrderDetailsActionTypes.CHANGE_ORDER + ',' + OrderDetailsActionTypes.REMOVE_FORWARD_TO_AGENT,
                },
                wording: {
                    headLine: 'common.commonLinks.chat.std-headline',
                    subHeadLine: 'common.commonLinks.chat.text-body',
                    icon: 'common.commonLinks.chat.opt-icon',
                },
            },
            {
                id: 'call-back-link',
                type: ACTION_TYPE.REDUX_ACTION,
                groupId: '1',
                actionDetails: {
                    dispatchAction: OrderDetailsActionTypes.REMOVE_BEFORE_UNLOAD_LISTENER + ',' + OrderDetailsActionTypes.SET_FORWARD_TO_AGENT + ',' + OrderDetailsActionTypes.CHANGE_ORDER,
                },
                wording: {
                    headLine: 'common.commonLinks.callBack.std-headline',
                    subHeadLine: 'common.commonLinks.callBack.text-body',
                    icon: 'common.commonLinks.callBack.opt-icon',
                },
            },
            ],
        },
        'revocation-step-two': {
            steps: [
                {
                    id: 'service-agent',
                    type: ACTION_TYPE.REDUX_ACTION,
                    groupId: '1',
                    actionDetails: {
                        dispatchAction: CustomerSupportActionTypes.STORE_CUSTOMER_SUPPORT_MESSAGES + ',' + OrderDetailsActionTypes.SET_TRANSACTION_NAME + ',' + RoutingActionType.START_ROUTING,
                    },
                    wording: {
                        headLine: 'common.commonLinks.serviceAgent.std-headline',
                        subHeadLine: 'common.commonLinks.serviceAgent.text-body',
                        icon: 'common.commonLinks.serviceAgent.opt-icon',
                    },
                },
                {
                    id: 'review-link',
                    groupId: '2',
                    hideInPostalShopping: true,
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: OrderDetailsActionTypes.RESET_POSITION + ',' + RoutingActionType.START_ROUTING,
                    },
                    wording: {
                        headLine: 'common.commonLinks.reviewPage.std-headline',
                        subHeadLine: 'common.commonLinks.reviewPage.text-body',
                        icon: 'common.commonLinks.reviewPage.opt-icon',
                    },
                },
            ],
        },
        'sales-agent': {
            steps: [
                {
                id: 'cancel-contract',
                hideInPostalShopping: true,
                type: ACTION_TYPE.REDUX_ACTION,
                groupId: '1',
                actionDetails: {
                    dispatchAction: CustomerSupportActionTypes.CUSTOMER_SUPPORT_CONTRACT_CANCELLATION,
                },
                wording: {
                    headLine: 'salesAgentModule.salesAgentPage.links.cancelContract.std-headline',
                    subHeadLine: 'salesAgentModule.salesAgentPage.links.cancelContract.text-body',
                    icon: 'revocationModule.simHardware.hardwareSelection.process.externalLinks.deviceRevocation.opt-icon',
                }},
            ],
        },
        'gigacube-revocation-options': {
            steps: [
                {
                    id: 'sales-agent-link',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: OrderDetailsActionTypes.SET_RETURN_REASON_CODE + ',' + OrderDetailsActionTypes.SET_TRANSACTION_NAME + ',' + OrderDetailsActionTypes.SET_FORWARD_TO_AGENT + ',' + OrderDetailsActionTypes.CHANGE_ORDER,
                    },
                    wording: {
                        headLine: 'common.links.salesAgent.std-headline',
                        subHeadLine: 'common.links.salesAgent.text-body',
                        icon: 'common.links.salesAgent.opt-icon',
                    },
                },
                {
                    id: 'open-questions-link',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: OrderDetailsActionTypes.SET_RETURN_REASON_CODE + ',' + OrderDetailsActionTypes.SET_TRANSACTION_NAME + ',' + OrderDetailsActionTypes.SET_FORWARD_TO_AGENT + ',' + RoutingActionType.START_ROUTING,
                    },
                    wording: {
                        headLine: 'common.links.openQuestions.std-headline',
                        subHeadLine: 'common.links.openQuestions.text-body',
                        icon: 'common.links.openQuestions.opt-icon',
                    },
                },
                {
                    id: 'winback-link',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: OrderDetailsActionTypes.SET_RETURN_REASON_CODE + ',' + OrderDetailsActionTypes.SET_TRANSACTION_NAME + ',' + RoutingActionType.START_ROUTING,
                    },
                    wording: {
                        headLine: 'common.links.winbackPage.std-headline',
                        subHeadLine: 'common.links.winbackPage.text-body',
                        icon: 'common.links.winbackPage.opt-icon',
                    },
                },
            ],
        },
        'gigacube-winback': {
            steps: [{
                id: 'gigacube-review-page',
                groupId: '1',
                type: ACTION_TYPE.REDUX_ACTION,
                actionDetails: {
                    dispatchAction: OrderDetailsActionTypes.RESET_POSITION + ',' + RoutingActionType.START_ROUTING,
                },
                wording: {
                    headLine: 'winbackModule.flowManagement.confirm.std-headline',
                    subHeadLine: 'winbackModule.flowManagement.confirm.std-subHeadline',
                    icon: 'common.commonLinks.reviewPage.opt-icon',
                },
            }],
        },
    },
    Lion: {
        'revocation-step-one': {
            extend: true,
        },
        'revocation-step-two': {
            extend: true,
        },
        'revocation-options': {
            extend: true,
        },
        'consultant-chooser': {
            extend: true,
            steps: [{
                id: 'review-link',
                hideInPostalShopping: true,
                groupId: '2',
                type: ACTION_TYPE.REDUX_ACTION,
                actionDetails: {
                    dispatchAction: RoutingActionType.START_ROUTING,
                },
                wording: {
                    headLine: 'common.commonLinks.reviewPage.std-headline',
                    subHeadLine: 'common.commonLinks.reviewPage.text-body',
                    icon: 'common.commonLinks.reviewPage.opt-icon',
                },
            }],
        },
        'open-questions-page': {
            extend: true,
        },
        'winback-page': {
            extend: true,
        },
        'sales-agent': {
            extend: true,
        },
    },
    Leopard: {
        'revocation-step-one': {
            extend: true,
        },
        'revocation-step-two': {
            extend: true,
        },
        'revocation-options': {
            extend: true,
        },
        'consultant-chooser': {
            extend: true,
            steps: [{
                id: 'review-link',
                hideInPostalShopping: true,
                groupId: '2',
                type: ACTION_TYPE.REDUX_ACTION,
                actionDetails: {
                    dispatchAction: RoutingActionType.START_ROUTING,
                },
                wording: {
                    headLine: 'common.commonLinks.reviewPage.std-headline',
                    subHeadLine: 'common.commonLinks.reviewPage.text-body',
                    icon: 'common.commonLinks.reviewPage.opt-icon',
                },
            }],
        },
        'open-questions-page': {
            extend: true,
        },
        'winback-page': {
            extend: true,
        },
        'sales-agent': {
            extend: true,
        },
    },
    NeoLion: {
       'revocation-step-one': {
            extend: true,
        },
        'revocation-step-two': {
            extend: true,
        },
        'revocation-options': {
            extend: true,
        },
        'consultant-chooser': {
            extend: true,
            steps: [{
                id: 'review-link',
                hideInPostalShopping: true,
                groupId: '2',
                type: ACTION_TYPE.REDUX_ACTION,
                actionDetails: {
                    dispatchAction: RoutingActionType.START_ROUTING,
                },
                wording: {
                    headLine: 'common.commonLinks.reviewPage.std-headline',
                    subHeadLine: 'common.commonLinks.reviewPage.text-body',
                    icon: 'common.commonLinks.reviewPage.opt-icon',
                },
            }],
        },
        'open-questions-page': {
            extend: true,
        },
        'winback-page': {
            extend: true,
        },
        'sales-agent': {
            extend: true,
        },
    },
    NeoLeopard: {
       'revocation-step-one': {
            extend: true,
        },
        'revocation-step-two': {
            extend: true,
        },
        'revocation-options': {
            extend: true,
        },
        'consultant-chooser': {
            extend: true,
            steps: [{
                id: 'review-link',
                hideInPostalShopping: true,
                groupId: '2',
                type: ACTION_TYPE.REDUX_ACTION,
                actionDetails: {
                    dispatchAction: RoutingActionType.START_ROUTING,
                },
                wording: {
                    headLine: 'common.commonLinks.reviewPage.std-headline',
                    subHeadLine: 'common.commonLinks.reviewPage.text-body',
                    icon: 'common.commonLinks.reviewPage.opt-icon',
                },
            }],
        },
        'open-questions-page': {
            extend: true,
        },
        'winback-page': {
            extend: true,
        },
        'sales-agent': {
            extend: true,
        },
    },
    Tiger: {
        'sim-revocation-options': {
            extend: true,
        },
        'open-questions-page': {
            extend: true,
        },
        'revocation-options': {
            extend: true,
        },
        'winback-page': {
            extend: true,
        },
        'consultant-chooser': {
            extend: true,
        },
        'sales-agent': {
            extend: true,
        },
    },
    Snowleopard: {
        'consultant-chooser': {
            extend: true,
        },
        'sales-agent': {
        steps: [{  // Additional review button that navigate to  /revock/simHardware
        id: 'review-items',
        automationId: `Sales_Agent_Send_Back_${ABBREVIATION_TABLE.TEXT_COMPONENT}`,
        type: ACTION_TYPE.REDUX_ACTION,
        groupId: '1',
        actionDetails: {
            dispatchAction: OrderDetailsActionTypes.SELECT_POSITION + ',' + CustomerSupportActionTypes.CUSTOMER_SUPPORT_REVIEW_ITEMS,
        },
        wording: {
            headLine: 'salesAgentModule.salesAgentPage.links.reviewItems.std-headline',
            subHeadLine: 'salesAgentModule.salesAgentPage.links.reviewItems.text-body',
            icon: 'revocationModule.simHardware.hardwareSelection.process.externalLinks.deviceRevocation.opt-icon',
        }}],
    }},
    Snowlion: {
        'consultant-chooser': {
            extend: true,
        },
        'sales-agent': {
            steps: [{  // Additional review button that navigate to  /revock/simHardware
            id: 'review-items',
            automationId: `Sales_Agent_Send_Back_${ABBREVIATION_TABLE.TEXT_COMPONENT}`,
            type: ACTION_TYPE.REDUX_ACTION,
            groupId: '1',
            actionDetails: {
                dispatchAction: OrderDetailsActionTypes.SELECT_POSITION + ',' + CustomerSupportActionTypes.CUSTOMER_SUPPORT_REVIEW_ITEMS,
            },
            wording: {
                headLine: 'salesAgentModule.salesAgentPage.links.reviewItems.std-headline',
                subHeadLine: 'salesAgentModule.salesAgentPage.links.reviewItems.text-body',
                icon: 'revocationModule.simHardware.hardwareSelection.process.externalLinks.deviceRevocation.opt-icon',
            }}],
        }},
    SnowNeoLeopard: {
        'consultant-chooser': {
            extend: true,
        },
        'sales-agent': {
            steps: [{  // Additional review button that navigate to  /revock/simHardware
            id: 'review-items',
            automationId: `Sales_Agent_Send_Back_${ABBREVIATION_TABLE.TEXT_COMPONENT}`,
            type: ACTION_TYPE.REDUX_ACTION,
            groupId: '1',
            actionDetails: {
                dispatchAction: OrderDetailsActionTypes.SELECT_POSITION + ',' + CustomerSupportActionTypes.CUSTOMER_SUPPORT_REVIEW_ITEMS,
            },
            wording: {
                headLine: 'salesAgentModule.salesAgentPage.links.reviewItems.std-headline',
                subHeadLine: 'salesAgentModule.salesAgentPage.links.reviewItems.text-body',
                icon: 'revocationModule.simHardware.hardwareSelection.process.externalLinks.deviceRevocation.opt-icon',
            }}],
        }},
    SnowNeoLion: {
        'consultant-chooser': {
            extend: true,
        },
        'sales-agent': {
            steps: [{  // Additional review button that navigate to  /revock/simHardware
            id: 'review-items',
            automationId: `Sales_Agent_Send_Back_${ABBREVIATION_TABLE.TEXT_COMPONENT}`,
            type: ACTION_TYPE.REDUX_ACTION,
            groupId: '1',
            actionDetails: {
                dispatchAction: OrderDetailsActionTypes.SELECT_POSITION + ',' + CustomerSupportActionTypes.CUSTOMER_SUPPORT_REVIEW_ITEMS,
            },
            wording: {
                headLine: 'salesAgentModule.salesAgentPage.links.reviewItems.std-headline',
                subHeadLine: 'salesAgentModule.salesAgentPage.links.reviewItems.text-body',
                icon: 'revocationModule.simHardware.hardwareSelection.process.externalLinks.deviceRevocation.opt-icon',
            }}],
        }},

    Polarbear: {
        'gigacube-revocation-options': {
            extend: true,
        },
        'gigacube-winback': {
            extend: true,
        },
        'open-questions-page': {
            extend: true,
        },
        'sales-agent': {
            extend: true,
        },
        'consultant-chooser': {
            extend: true,
        },
    },
    SnowPolarbear: {
        'sales-agent': {
            steps: [{  // Additional review button that navigate to  /revock/simHardware
            id: 'review-items',
            automationId: `Sales_Agent_Send_Back_${ABBREVIATION_TABLE.TEXT_COMPONENT}`,
            type: ACTION_TYPE.REDUX_ACTION,
            groupId: '1',
            actionDetails: {
                dispatchAction:  OrderDetailsActionTypes.SELECT_POSITION + ',' + CustomerSupportActionTypes.CUSTOMER_SUPPORT_REVIEW_ITEMS ,
            },
            wording: {
                headLine: 'salesAgentModule.salesAgentPage.links.reviewItems.std-headline',
                subHeadLine: 'salesAgentModule.salesAgentPage.links.reviewItems.text-body',
                icon: 'revocationModule.simHardware.hardwareSelection.process.externalLinks.deviceRevocation.opt-icon',
            }}],
        },
        'consultant-chooser': {
            extend: true,
        },
    },
    NeoTiger: {
        'sim-revocation-options': {
            extend: true,
        },
        'open-questions-page': {
            extend: true,
        },
        'revocation-options': {
            extend: true,
        },
        'winback-page': {
            extend: true,
        },
        'consultant-chooser': {
            extend: true,
        },
        'sales-agent': {
            extend: true,
        },
    },
    Giraffe: {
        'um-cable-reason-chooser': {
            steps: [
                {

                    id: 'technical-problems',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'revocationModule.um-cable-reason-chooser.Giraffe.options.technicalProblem.isHidden.text-body',
                    order: 'revocationModule.um-cable-reason-chooser.Giraffe.options.technicalProblem.order.std-headline',
                    wording: {
                        headLine: 'revocationModule.um-cable-reason-chooser.Giraffe.options.technicalProblem.std-headline',
                        subHeadLine: 'revocationModule.um-cable-reason-chooser.Giraffe.options.technicalProblem.std-subHeadline',
                        icon: 'revocationModule.um-cable-reason-chooser.Giraffe.options.technicalProblem.opt-icon',
                    },
                },
                {
                    id: 'tariff-problems',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'revocationModule.um-cable-reason-chooser.Giraffe.options.tariffProblem.isHidden.text-body',
                    order: 'revocationModule.um-cable-reason-chooser.Giraffe.options.tariffProblem.order.std-headline',
                    wording: {
                        headLine: 'revocationModule.um-cable-reason-chooser.Giraffe.options.tariffProblem.std-headline',
                        subHeadLine: 'revocationModule.um-cable-reason-chooser.Giraffe.options.tariffProblem.std-subHeadline',
                        icon: 'revocationModule.um-cable-reason-chooser.Giraffe.options.tariffProblem.opt-icon',
                    },
                },
                {
                    id: 'have-questions',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'revocationModule.um-cable-reason-chooser.Giraffe.options.haveQuestions.isHidden.text-body',
                    order: 'revocationModule.um-cable-reason-chooser.Giraffe.options.haveQuestions.order.std-headline',
                    wording: {
                        headLine: 'revocationModule.um-cable-reason-chooser.Giraffe.options.haveQuestions.std-headline',
                        subHeadLine: 'revocationModule.um-cable-reason-chooser.Giraffe.options.haveQuestions.std-subHeadline',
                        icon: 'revocationModule.um-cable-reason-chooser.Giraffe.options.haveQuestions.opt-icon',
                    },
                },
                {
                    id: 'marketing-one',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'revocationModule.um-cable-reason-chooser.Giraffe.options.marketingOne.isHidden.text-body',
                    order: 'revocationModule.um-cable-reason-chooser.Giraffe.options.marketingOne.order.std-headline',
                    wording: {
                        headLine: 'revocationModule.um-cable-reason-chooser.Giraffe.options.marketingOne.std-headline',
                        subHeadLine: 'revocationModule.um-cable-reason-chooser.Giraffe.options.marketingOne.std-subHeadline',
                        icon: 'revocationModule.um-cable-reason-chooser.Giraffe.options.marketingOne.opt-icon',
                    },
                },
                {
                    id: 'marketing-two',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'revocationModule.um-cable-reason-chooser.Giraffe.options.marketingTwo.isHidden.text-body',
                    order: 'revocationModule.um-cable-reason-chooser.Giraffe.options.marketingTwo.order.std-headline',
                    wording: {
                        headLine: 'revocationModule.um-cable-reason-chooser.Giraffe.options.marketingTwo.std-headline',
                        subHeadLine: 'revocationModule.um-cable-reason-chooser.Giraffe.options.marketingTwo.std-subHeadline',
                        icon: 'revocationModule.um-cable-reason-chooser.Giraffe.options.marketingTwo.opt-icon',
                    },
                },
                {
                    id: 'marketing-three',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: OverlayActionType.TOGGLE_OVERLAY,
                    },
                    isHidden: 'revocationModule.um-cable-reason-chooser.Giraffe.options.marketingThree.isHidden.text-body',
                    order: 'revocationModule.um-cable-reason-chooser.Giraffe.options.marketingThree.order.std-headline',
                    wording: {
                        headLine: 'revocationModule.um-cable-reason-chooser.Giraffe.options.marketingThree.std-headline',
                        subHeadLine: 'revocationModule.um-cable-reason-chooser.Giraffe.options.marketingThree.std-subHeadline',
                        icon: 'revocationModule.um-cable-reason-chooser.Giraffe.options.marketingThree.opt-icon',
                    },
                },
                {
                    id: 'other-reason',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'revocationModule.um-cable-reason-chooser.Giraffe.options.otherReason.isHidden.text-body',
                    order: 'revocationModule.um-cable-reason-chooser.Giraffe.options.otherReason.order.std-headline',
                    wording: {
                        headLine: 'revocationModule.um-cable-reason-chooser.Giraffe.options.otherReason.std-headline',
                        subHeadLine: 'revocationModule.um-cable-reason-chooser.Giraffe.options.otherReason.std-subHeadline',
                        icon: 'revocationModule.um-cable-reason-chooser.Giraffe.options.otherReason.opt-icon',
                    },
                },
            ],
    },
        'um-kd-sales-agent': {
            steps: [
                {
                id: 'call-us',
                hideOnMobile: true,
                cursorAuto: true,
                isHidden: 'UmCableSalesAgentPage.Giraffe.links.callUs.isHidden.text-body',
                wording: {
                    headLine: 'UmCableSalesAgentPage.Giraffe.links.callUs.number.std-headline',
                    subHeadLine: 'UmCableSalesAgentPage.Giraffe.links.callUs.text-body',
                    icon: 'UmCableSalesAgentPage.Giraffe.links.callUs.opt-icon',
                }},
                {
                    id: 'chat-us',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'UmCableSalesAgentPage.Giraffe.links.chat-us.isHidden.text-body',
                    wording: {
                        headLine: 'UmCableSalesAgentPage.Giraffe.links.chat-us.std-headline',
                        subHeadLine: 'UmCableSalesAgentPage.Giraffe.links.chat-us.text-body',
                        icon: 'UmCableSalesAgentPage.Giraffe.links.chat-us.opt-icon',
                }},
                {
                        id: 'our-recall',
                        type: ACTION_TYPE.REDUX_ACTION,
                        actionDetails: {
                            dispatchAction: RoutingActionType.START_ROUTING,
                        },
                        isHidden: 'UmCableSalesAgentPage.Giraffe.links.our-recall.isHidden.text-body',
                        wording: {
                            headLine: 'UmCableSalesAgentPage.Giraffe.links.our-recall.std-headline',
                            subHeadLine: 'UmCableSalesAgentPage.Giraffe.links.our-recall.text-body',
                            icon: 'UmCableSalesAgentPage.Giraffe.links.our-recall.opt-icon',
                }},
                {
                        id: 'cancel-now',
                        type: ACTION_TYPE.REDUX_ACTION,
                        actionDetails: {
                            dispatchAction: RoutingActionType.START_ROUTING,
                        },
                        isHidden: 'UmCableSalesAgentPage.Giraffe.links.cancel-now.isHidden.text-body',
                        wording: {
                            headLine: 'UmCableSalesAgentPage.Giraffe.links.cancel-now.std-headline',
                            subHeadLine: 'UmCableSalesAgentPage.Giraffe.links.cancel-now.text-body',
                            icon: 'UmCableSalesAgentPage.Giraffe.links.cancel-now.opt-icon',
                }},
            ],
        },
        'cancelTechnicalProblems': {
            steps: [
                {
                id: 'call-us',
                hideOnMobile: true,
                cursorAuto: true,
                isHidden: 'UmCableSalesAgentPage.cancelTechnicalProblems.Giraffe.links.callUs.isHidden.text-body',
                wording: {
                    headLine: 'UmCableSalesAgentPage.cancelTechnicalProblems.Giraffe.links.callUs.number.std-headline',
                    subHeadLine: 'UmCableSalesAgentPage.cancelTechnicalProblems.Giraffe.links.callUs.text-body',
                    icon: 'UmCableSalesAgentPage.cancelTechnicalProblems.Giraffe.links.callUs.opt-icon',
                }},
                {
                    id: 'chat-us',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'UmCableSalesAgentPage.cancelTechnicalProblems.Giraffe.links.chat-us.isHidden.text-body',
                    wording: {
                        headLine: 'UmCableSalesAgentPage.cancelTechnicalProblems.Giraffe.links.chat-us.std-headline',
                        subHeadLine: 'UmCableSalesAgentPage.cancelTechnicalProblems.Giraffe.links.chat-us.text-body',
                        icon: 'UmCableSalesAgentPage.cancelTechnicalProblems.Giraffe.links.chat-us.opt-icon',
                }},
                {
                        id: 'our-recall',
                        type: ACTION_TYPE.REDUX_ACTION,
                        actionDetails: {
                            dispatchAction: RoutingActionType.START_ROUTING,
                        },
                        isHidden: 'UmCableSalesAgentPage.cancelTechnicalProblems.Giraffe.links.our-recall.isHidden.text-body',
                        wording: {
                            headLine: 'UmCableSalesAgentPage.cancelTechnicalProblems.Giraffe.links.our-recall.std-headline',
                            subHeadLine: 'UmCableSalesAgentPage.cancelTechnicalProblems.Giraffe.links.our-recall.text-body',
                            icon: 'UmCableSalesAgentPage.cancelTechnicalProblems.Giraffe.links.our-recall.opt-icon',
                }},
                {
                        id: 'cancel-now',
                        type: ACTION_TYPE.REDUX_ACTION,
                        actionDetails: {
                            dispatchAction: RoutingActionType.START_ROUTING,
                        },
                        isHidden: 'UmCableSalesAgentPage.cancelTechnicalProblems.Giraffe.links.cancel-now.isHidden.text-body',
                        wording: {
                            headLine: 'UmCableSalesAgentPage.cancelTechnicalProblems.Giraffe.links.cancel-now.std-headline',
                            subHeadLine: 'UmCableSalesAgentPage.cancelTechnicalProblems.Giraffe.links.cancel-now.text-body',
                            icon: 'UmCableSalesAgentPage.cancelTechnicalProblems.Giraffe.links.cancel-now.opt-icon',
                }},
            ],
        },
    },
    Camel: {
        'um-cable-reason-chooser': {
            steps: [
                {
                    id: 'technical-problems',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'revocationModule.um-cable-reason-chooser.Camel.options.technicalProblem.isHidden.text-body',
                    order: 'revocationModule.um-cable-reason-chooser.Camel.options.technicalProblem.order.std-headline',
                    wording: {
                        headLine: 'revocationModule.um-cable-reason-chooser.Camel.options.technicalProblem.std-headline',
                        subHeadLine: 'revocationModule.um-cable-reason-chooser.Camel.options.technicalProblem.std-subHeadline',
                        icon: 'revocationModule.um-cable-reason-chooser.Camel.options.technicalProblem.opt-icon',
                    },
                },
                {
                    id: 'tariff-problems',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'revocationModule.um-cable-reason-chooser.Camel.options.tariffProblem.isHidden.text-body',
                    order: 'revocationModule.um-cable-reason-chooser.Camel.options.tariffProblem.order.std-headline',
                    wording: {
                        headLine: 'revocationModule.um-cable-reason-chooser.Camel.options.tariffProblem.std-headline',
                        subHeadLine: 'revocationModule.um-cable-reason-chooser.Camel.options.tariffProblem.std-subHeadline',
                        icon: 'revocationModule.um-cable-reason-chooser.Camel.options.tariffProblem.opt-icon',
                    },
                },
                {

                    id: 'have-questions',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'revocationModule.um-cable-reason-chooser.Camel.options.haveQuestions.isHidden.text-body',
                    order: 'revocationModule.um-cable-reason-chooser.Camel.options.haveQuestions.order.std-headline',
                    wording: {
                        headLine: 'revocationModule.um-cable-reason-chooser.Camel.options.haveQuestions.std-headline',
                        subHeadLine: 'revocationModule.um-cable-reason-chooser.Camel.options.haveQuestions.std-subHeadline',
                        icon: 'revocationModule.um-cable-reason-chooser.Camel.options.haveQuestions.opt-icon',
                    },
                },
                {
                    id: 'marketing-one',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'revocationModule.um-cable-reason-chooser.Camel.options.marketingOne.isHidden.text-body',
                    order: 'revocationModule.um-cable-reason-chooser.Camel.options.marketingOne.order.std-headline',
                    wording: {
                        headLine: 'revocationModule.um-cable-reason-chooser.Camel.options.marketingOne.std-headline',
                        subHeadLine: 'revocationModule.um-cable-reason-chooser.Camel.options.marketingOne.std-subHeadline',
                        icon: 'revocationModule.um-cable-reason-chooser.Camel.options.marketingOne.opt-icon',
                    },
                },
                {
                    id: 'marketing-two',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'revocationModule.um-cable-reason-chooser.Camel.options.marketingTwo.isHidden.text-body',
                    order: 'revocationModule.um-cable-reason-chooser.Camel.options.marketingTwo.order.std-headline',
                    wording: {
                        headLine: 'revocationModule.um-cable-reason-chooser.Camel.options.marketingTwo.std-headline',
                        subHeadLine: 'revocationModule.um-cable-reason-chooser.Camel.options.marketingTwo.std-subHeadline',
                        icon: 'revocationModule.um-cable-reason-chooser.Camel.options.marketingTwo.opt-icon',
                    },
                },
                {
                    id: 'marketing-three',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: OverlayActionType.TOGGLE_OVERLAY,
                    },
                    isHidden: 'revocationModule.um-cable-reason-chooser.Camel.options.marketingThree.isHidden.text-body',
                    order: 'revocationModule.um-cable-reason-chooser.Camel.options.marketingThree.order.std-headline',
                    wording: {
                        headLine: 'revocationModule.um-cable-reason-chooser.Camel.options.marketingThree.std-headline',
                        subHeadLine: 'revocationModule.um-cable-reason-chooser.Camel.options.marketingThree.std-subHeadline',
                        icon: 'revocationModule.um-cable-reason-chooser.Camel.options.marketingThree.opt-icon',
                    },
                },
                {
                    id: 'other-reason',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'revocationModule.um-cable-reason-chooser.Camel.options.otherReason.isHidden.text-body',
                    order: 'revocationModule.um-cable-reason-chooser.Camel.options.otherReason.order.std-headline',
                    wording: {
                        headLine: 'revocationModule.um-cable-reason-chooser.Camel.options.otherReason.std-headline',
                        subHeadLine: 'revocationModule.um-cable-reason-chooser.Camel.options.otherReason.std-subHeadline',
                        icon: 'revocationModule.um-cable-reason-chooser.Camel.options.otherReason.opt-icon',
                    },
                },
            ],
    },
        'um-kd-sales-agent': {
            steps: [
                {
                id: 'call-us',
                hideOnMobile: true,
                cursorAuto: true,
                isHidden: 'UmCableSalesAgentPage.Camel.links.callUs.isHidden.text-body',
                wording: {
                    headLine: 'UmCableSalesAgentPage.Camel.links.callUs.number.std-headline',
                    subHeadLine: 'UmCableSalesAgentPage.Camel.links.callUs.text-body',
                    icon: 'UmCableSalesAgentPage.Camel.links.callUs.opt-icon',
                }},
                {
                    id: 'chat-us',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'UmCableSalesAgentPage.Camel.links.chat-us.isHidden.text-body',
                    wording: {
                        headLine: 'UmCableSalesAgentPage.Camel.links.chat-us.std-headline',
                        subHeadLine: 'UmCableSalesAgentPage.Camel.links.chat-us.text-body',
                        icon: 'UmCableSalesAgentPage.Camel.links.chat-us.opt-icon',
                }},
                {
                        id: 'our-recall',
                        type: ACTION_TYPE.REDUX_ACTION,
                        actionDetails: {
                            dispatchAction: RoutingActionType.START_ROUTING,
                        },
                        isHidden: 'UmCableSalesAgentPage.Camel.links.our-recall.isHidden.text-body',
                        wording: {
                            headLine: 'UmCableSalesAgentPage.Camel.links.our-recall.std-headline',
                            subHeadLine: 'UmCableSalesAgentPage.Camel.links.our-recall.text-body',
                            icon: 'UmCableSalesAgentPage.Camel.links.our-recall.opt-icon',
                }},
                {
                        id: 'cancel-now',
                        type: ACTION_TYPE.REDUX_ACTION,
                        actionDetails: {
                            dispatchAction: RoutingActionType.START_ROUTING,
                        },
                        isHidden: 'UmCableSalesAgentPage.Camel.links.cancel-now.isHidden.text-body',
                        wording: {
                            headLine: 'UmCableSalesAgentPage.Camel.links.cancel-now.std-headline',
                            subHeadLine: 'UmCableSalesAgentPage.Camel.links.cancel-now.text-body',
                            icon: 'UmCableSalesAgentPage.Camel.links.cancel-now.opt-icon',
                }},
            ],
        },
        'cancelTechnicalProblems': {
            steps: [
                {
                id: 'call-us',
                hideOnMobile: true,
                cursorAuto: true,
                isHidden: 'UmCableSalesAgentPage.cancelTechnicalProblems.Camel.links.callUs.isHidden.text-body',
                wording: {
                    headLine: 'UmCableSalesAgentPage.cancelTechnicalProblems.Camel.links.callUs.number.std-headline',
                    subHeadLine: 'UmCableSalesAgentPage.cancelTechnicalProblems.Camel.links.callUs.text-body',
                    icon: 'UmCableSalesAgentPage.cancelTechnicalProblems.Camel.links.callUs.opt-icon',
                }},
                {
                    id: 'chat-us',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'UmCableSalesAgentPage.cancelTechnicalProblems.Camel.links.chat-us.isHidden.text-body',
                    wording: {
                        headLine: 'UmCableSalesAgentPage.cancelTechnicalProblems.Camel.links.chat-us.std-headline',
                        subHeadLine: 'UmCableSalesAgentPage.cancelTechnicalProblems.Camel.links.chat-us.text-body',
                        icon: 'UmCableSalesAgentPage.cancelTechnicalProblems.Camel.links.chat-us.opt-icon',
                }},
                {
                        id: 'our-recall',
                        type: ACTION_TYPE.REDUX_ACTION,
                        actionDetails: {
                            dispatchAction: RoutingActionType.START_ROUTING,
                        },
                        isHidden: 'UmCableSalesAgentPage.cancelTechnicalProblems.Camel.links.our-recall.isHidden.text-body',
                        wording: {
                            headLine: 'UmCableSalesAgentPage.cancelTechnicalProblems.Camel.links.our-recall.std-headline',
                            subHeadLine: 'UmCableSalesAgentPage.cancelTechnicalProblems.Camel.links.our-recall.text-body',
                            icon: 'UmCableSalesAgentPage.cancelTechnicalProblems.Camel.links.our-recall.opt-icon',
                }},
                {
                        id: 'cancel-now',
                        type: ACTION_TYPE.REDUX_ACTION,
                        actionDetails: {
                            dispatchAction: RoutingActionType.START_ROUTING,
                        },
                        isHidden: 'UmCableSalesAgentPage.cancelTechnicalProblems.Camel.links.cancel-now.isHidden.text-body',
                        wording: {
                            headLine: 'UmCableSalesAgentPage.cancelTechnicalProblems.Camel.links.cancel-now.std-headline',
                            subHeadLine: 'UmCableSalesAgentPage.cancelTechnicalProblems.Camel.links.cancel-now.text-body',
                            icon: 'UmCableSalesAgentPage.cancelTechnicalProblems.Camel.links.cancel-now.opt-icon',
                }},
            ],
        },
    },
    Deer: {
        'um-cable-reason-chooser': {
            steps: [
                {
                    id: 'moved',
                    type: ACTION_TYPE.NAVIGATION_ACTION,
                    linkDetails: {
                        routeURL: 'terminationModule.um-cable-reason-chooser.Deer.options.moved.link-href',
                        isExternal: true,
                        target: '_blank',
                    },
                    isHidden: 'terminationModule.um-cable-reason-chooser.Deer.options.moved.isHidden.text-body',
                    order: 'terminationModule.um-cable-reason-chooser.Deer.options.moved.order.std-headline',
                    wording: {
                        headLine: 'terminationModule.um-cable-reason-chooser.Deer.options.moved.std-headline',
                        subHeadLine: 'terminationModule.um-cable-reason-chooser.Deer.options.moved.std-subHeadline',
                        icon: 'terminationModule.um-cable-reason-chooser.Deer.options.moved.opt-icon',
                    },
                },
                {
                    id: 'there-a-death',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'terminationModule.um-cable-reason-chooser.Deer.options.thereDeath.isHidden.text-body',
                    order: 'terminationModule.um-cable-reason-chooser.Deer.options.thereDeath.order.std-headline',
                    wording: {
                        headLine: 'terminationModule.um-cable-reason-chooser.Deer.options.thereDeath.std-headline',
                        subHeadLine: 'terminationModule.um-cable-reason-chooser.Deer.options.thereDeath.std-subHeadline',
                        icon: 'terminationModule.um-cable-reason-chooser.Deer.options.thereDeath.opt-icon',
                    },
                },
                {
                    id: 'have-questions',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'terminationModule.um-cable-reason-chooser.Deer.options.haveQuestions.isHidden.text-body',
                    order: 'terminationModule.um-cable-reason-chooser.Deer.options.haveQuestions.order.std-headline',
                    wording: {
                        headLine: 'terminationModule.um-cable-reason-chooser.Deer.options.haveQuestions.std-headline',
                        subHeadLine: 'terminationModule.um-cable-reason-chooser.Deer.options.haveQuestions.std-subHeadline',
                        icon: 'terminationModule.um-cable-reason-chooser.Deer.options.haveQuestions.opt-icon',
                    },
                },
                {
                    id: 'tariff-satisfaction',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'terminationModule.um-cable-reason-chooser.Deer.options.tariffSatisfaction.isHidden.text-body',
                    order: 'terminationModule.um-cable-reason-chooser.Deer.options.tariffSatisfaction.order.std-headline',
                    wording: {
                        headLine: 'terminationModule.um-cable-reason-chooser.Deer.options.tariffSatisfaction.std-headline',
                        subHeadLine: 'terminationModule.um-cable-reason-chooser.Deer.options.tariffSatisfaction.std-subHeadline',
                        icon: 'terminationModule.um-cable-reason-chooser.Deer.options.tariffSatisfaction.opt-icon',
                    },
                },
                {
                    id: 'marketing-one',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'terminationModule.um-cable-reason-chooser.Deer.options.marketingOne.isHidden.text-body',
                    order: 'terminationModule.um-cable-reason-chooser.Deer.options.marketingOne.order.std-headline',
                    wording: {
                        headLine: 'terminationModule.um-cable-reason-chooser.Deer.options.marketingOne.std-headline',
                        subHeadLine: 'terminationModule.um-cable-reason-chooser.Deer.options.marketingOne.std-subHeadline',
                        icon: 'terminationModule.um-cable-reason-chooser.Deer.options.marketingOne.opt-icon',
                    },
                },
                {
                    id: 'marketing-two',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: OverlayActionType.TOGGLE_OVERLAY,
                    },
                    isHidden: 'terminationModule.um-cable-reason-chooser.Deer.options.marketingTwo.isHidden.text-body',
                    order: 'terminationModule.um-cable-reason-chooser.Deer.options.marketingTwo.order.std-headline',
                    wording: {
                        headLine: 'terminationModule.um-cable-reason-chooser.Deer.options.marketingTwo.std-headline',
                        subHeadLine: 'terminationModule.um-cable-reason-chooser.Deer.options.marketingTwo.std-subHeadline',
                        icon: 'terminationModule.um-cable-reason-chooser.Deer.options.marketingTwo.opt-icon',
                    },
                },
                {
                    id: 'other-reason',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'terminationModule.um-cable-reason-chooser.Deer.options.otherReason.isHidden.text-body',
                    order: 'terminationModule.um-cable-reason-chooser.Deer.options.otherReason.order.std-headline',
                    wording: {
                        headLine: 'terminationModule.um-cable-reason-chooser.Deer.options.otherReason.std-headline',
                        subHeadLine: 'terminationModule.um-cable-reason-chooser.Deer.options.otherReason.std-subHeadline',
                        icon: 'terminationModule.um-cable-reason-chooser.Deer.options.otherReason.opt-icon',
                    },
                },
            ],
        },
        'um-kd-sales-agent': {
            steps: [
                {
                id: 'call-us',
                hideOnMobile: true,
                cursorAuto: true,
                isHidden: 'UmCableSalesAgentPage.Deer.links.callUs.isHidden.text-body',
                wording: {
                    headLine: 'UmCableSalesAgentPage.Deer.links.callUs.number.std-headline',
                    subHeadLine: 'UmCableSalesAgentPage.Deer.links.callUs.text-body',
                    icon: 'UmCableSalesAgentPage.Deer.links.callUs.opt-icon',
                }},
                {
                    id: 'chat-us',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'UmCableSalesAgentPage.Deer.links.chat-us.isHidden.text-body',
                    wording: {
                        headLine: 'UmCableSalesAgentPage.Deer.links.chat-us.std-headline',
                        subHeadLine: 'UmCableSalesAgentPage.Deer.links.chat-us.text-body',
                        icon: 'UmCableSalesAgentPage.Deer.links.chat-us.opt-icon',
                }},
                {
                        id: 'our-recall',
                        type: ACTION_TYPE.REDUX_ACTION,
                        actionDetails: {
                            dispatchAction: RoutingActionType.START_ROUTING,
                        },
                        isHidden: 'UmCableSalesAgentPage.Deer.links.our-recall.isHidden.text-body',
                        wording: {
                            headLine: 'UmCableSalesAgentPage.Deer.links.our-recall.std-headline',
                            subHeadLine: 'UmCableSalesAgentPage.Deer.links.our-recall.text-body',
                            icon: 'UmCableSalesAgentPage.Deer.links.our-recall.opt-icon',
                }},
                {
                        id: 'cancel-now',
                        type: ACTION_TYPE.REDUX_ACTION,
                        actionDetails: {
                            dispatchAction: RoutingActionType.START_ROUTING,
                        },
                        isHidden: 'UmCableSalesAgentPage.Deer.links.cancel-now.isHidden.text-body',
                        wording: {
                            headLine: 'UmCableSalesAgentPage.Deer.links.cancel-now.std-headline',
                            subHeadLine: 'UmCableSalesAgentPage.Deer.links.cancel-now.text-body',
                            icon: 'UmCableSalesAgentPage.Deer.links.cancel-now.opt-icon',
                }},
            ],
        },
    },
    Fox: {
        'um-cable-reason-chooser': {
            steps: [
                {
                    id: 'moved',
                    type: ACTION_TYPE.NAVIGATION_ACTION,
                    linkDetails: {
                        routeURL: 'terminationModule.um-cable-reason-chooser.Fox.options.moved.link-href',
                        isExternal: true,
                        target: '_blank',
                    },
                    isHidden: 'terminationModule.um-cable-reason-chooser.Fox.options.moved.isHidden.text-body',
                    order: 'terminationModule.um-cable-reason-chooser.Fox.options.moved.order.std-headline',
                    wording: {
                        headLine: 'terminationModule.um-cable-reason-chooser.Fox.options.moved.std-headline',
                        subHeadLine: 'terminationModule.um-cable-reason-chooser.Fox.options.moved.std-subHeadline',
                        icon: 'terminationModule.um-cable-reason-chooser.Fox.options.moved.opt-icon',
                    },
                },
                {
                    id: 'there-a-death',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'terminationModule.um-cable-reason-chooser.Fox.options.thereDeath.isHidden.text-body',
                    order: 'terminationModule.um-cable-reason-chooser.Fox.options.thereDeath.order.std-headline',
                    wording: {
                        headLine: 'terminationModule.um-cable-reason-chooser.Fox.options.thereDeath.std-headline',
                        subHeadLine: 'terminationModule.um-cable-reason-chooser.Fox.options.thereDeath.std-subHeadline',
                        icon: 'terminationModule.um-cable-reason-chooser.Fox.options.thereDeath.opt-icon',
                    },
                },
                {
                    id: 'have-questions',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'terminationModule.um-cable-reason-chooser.Fox.options.haveQuestions.isHidden.text-body',
                    order: 'terminationModule.um-cable-reason-chooser.Fox.options.haveQuestions.order.std-headline',
                    wording: {
                        headLine: 'terminationModule.um-cable-reason-chooser.Fox.options.haveQuestions.std-headline',
                        subHeadLine: 'terminationModule.um-cable-reason-chooser.Fox.options.haveQuestions.std-subHeadline',
                        icon: 'terminationModule.um-cable-reason-chooser.Fox.options.haveQuestions.opt-icon',
                    },

                },
                {
                    id: 'tariff-satisfaction',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'terminationModule.um-cable-reason-chooser.Fox.options.tariffSatisfaction.isHidden.text-body',
                    order: 'terminationModule.um-cable-reason-chooser.Fox.options.tariffSatisfaction.order.std-headline',
                    wording: {
                        headLine: 'terminationModule.um-cable-reason-chooser.Fox.options.tariffSatisfaction.std-headline',
                        subHeadLine: 'terminationModule.um-cable-reason-chooser.Fox.options.tariffSatisfaction.std-subHeadline',
                        icon: 'terminationModule.um-cable-reason-chooser.Fox.options.tariffSatisfaction.opt-icon',
                    },
                },
                {
                    id: 'marketing-one',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'terminationModule.um-cable-reason-chooser.Fox.options.marketingOne.isHidden.text-body',
                    order: 'terminationModule.um-cable-reason-chooser.Fox.options.marketingOne.order.std-headline',
                    wording: {
                        headLine: 'terminationModule.um-cable-reason-chooser.Fox.options.marketingOne.std-headline',
                        subHeadLine: 'terminationModule.um-cable-reason-chooser.Fox.options.marketingOne.std-subHeadline',
                        icon: 'terminationModule.um-cable-reason-chooser.Fox.options.marketingOne.opt-icon',

                    },
                },
                {
                    id: 'marketing-two',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: OverlayActionType.TOGGLE_OVERLAY,
                    },
                    isHidden: 'terminationModule.um-cable-reason-chooser.Fox.options.marketingTwo.isHidden.text-body',
                    order: 'terminationModule.um-cable-reason-chooser.Fox.options.marketingTwo.order.std-headline',
                    wording: {
                        headLine: 'terminationModule.um-cable-reason-chooser.Fox.options.marketingTwo.std-headline',
                        subHeadLine: 'terminationModule.um-cable-reason-chooser.Fox.options.marketingTwo.std-subHeadline',
                        icon: 'terminationModule.um-cable-reason-chooser.Fox.options.marketingTwo.opt-icon',
                    },
                },
                {
                    id: 'other-reason',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'terminationModule.um-cable-reason-chooser.Fox.options.otherReason.isHidden.text-body',
                    order: 'terminationModule.um-cable-reason-chooser.Fox.options.otherReason.order.std-headline',
                    wording: {
                        headLine: 'terminationModule.um-cable-reason-chooser.Fox.options.otherReason.std-headline',
                        subHeadLine: 'terminationModule.um-cable-reason-chooser.Fox.options.otherReason.std-subHeadline',
                        icon: 'terminationModule.um-cable-reason-chooser.Fox.options.otherReason.opt-icon',

                    },
                },
            ],
        },
        'um-kd-sales-agent': {
            steps: [
                {
                id: 'call-us',
                hideOnMobile: true,
                cursorAuto: true,
                isHidden: 'UmCableSalesAgentPage.Fox.links.callUs.isHidden.text-body',
                wording: {
                    headLine: 'UmCableSalesAgentPage.Fox.links.callUs.number.std-headline',
                    subHeadLine: 'UmCableSalesAgentPage.Fox.links.callUs.text-body',
                    icon: 'UmCableSalesAgentPage.Fox.links.callUs.opt-icon',
                }},
                {
                    id: 'chat-us',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'UmCableSalesAgentPage.Fox.links.chat-us.isHidden.text-body',
                    wording: {
                        headLine: 'UmCableSalesAgentPage.Fox.links.chat-us.std-headline',
                        subHeadLine: 'UmCableSalesAgentPage.Fox.links.chat-us.text-body',
                        icon: 'UmCableSalesAgentPage.Fox.links.chat-us.opt-icon',
                }},
                {
                        id: 'our-recall',
                        type: ACTION_TYPE.REDUX_ACTION,
                        actionDetails: {
                            dispatchAction: RoutingActionType.START_ROUTING,
                        },
                        isHidden: 'UmCableSalesAgentPage.Fox.links.our-recall.isHidden.text-body',
                        wording: {
                            headLine: 'UmCableSalesAgentPage.Fox.links.our-recall.std-headline',
                            subHeadLine: 'UmCableSalesAgentPage.Fox.links.our-recall.text-body',
                            icon: 'UmCableSalesAgentPage.Fox.links.our-recall.opt-icon',
                }},
                {
                        id: 'cancel-now',
                        type: ACTION_TYPE.REDUX_ACTION,
                        actionDetails: {
                            dispatchAction: RoutingActionType.START_ROUTING,
                        },
                        isHidden: 'UmCableSalesAgentPage.Fox.links.cancel-now.isHidden.text-body',
                        wording: {
                            headLine: 'UmCableSalesAgentPage.Fox.links.cancel-now.std-headline',
                            subHeadLine: 'UmCableSalesAgentPage.Fox.links.cancel-now.text-body',
                            icon: 'UmCableSalesAgentPage.Fox.links.cancel-now.opt-icon',
                }},
            ],
        },
    },
    Buffalo: {
        'dsl-reason-chooser': {
            steps: [
                {
                    id: 'technical-problems',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'revocationModule.dslReasonChooser.Buffalo.options.technicalProblem.isHidden.text-body',
                    order: 'revocationModule.dslReasonChooser.Buffalo.options.technicalProblem.order.std-headline',
                    wording: {
                        headLine: 'revocationModule.dslReasonChooser.Buffalo.options.technicalProblem.std-headline',
                        subHeadLine: 'revocationModule.dslReasonChooser.Buffalo.options.technicalProblem.std-subHeadline',
                        icon: 'revocationModule.dslReasonChooser.Buffalo.options.technicalProblem.opt-icon',
                    },
                },
                {
                    id: 'tariff-problems',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'revocationModule.dslReasonChooser.Buffalo.options.tariffProblem.isHidden.text-body',
                    order: 'revocationModule.dslReasonChooser.Buffalo.options.tariffProblem.order.std-headline',
                    wording: {
                        headLine: 'revocationModule.dslReasonChooser.Buffalo.options.tariffProblem.std-headline',
                        subHeadLine: 'revocationModule.dslReasonChooser.Buffalo.options.tariffProblem.std-subHeadline',
                        icon: 'revocationModule.dslReasonChooser.Buffalo.options.tariffProblem.opt-icon',
                    },
                },
                {
                    id: 'have-questions',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'revocationModule.dslReasonChooser.Buffalo.options.haveQuestions.isHidden.text-body',
                    order: 'revocationModule.dslReasonChooser.Buffalo.options.haveQuestions.order.std-headline',
                    wording: {
                        headLine: 'revocationModule.dslReasonChooser.Buffalo.options.haveQuestions.std-headline',
                        subHeadLine: 'revocationModule.dslReasonChooser.Buffalo.options.haveQuestions.std-subHeadline',
                        icon: 'revocationModule.dslReasonChooser.Buffalo.options.haveQuestions.opt-icon',
                    },
                },
                {
                    id: 'marketing-one',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'revocationModule.dslReasonChooser.Buffalo.options.marketingOne.isHidden.text-body',
                    order: 'revocationModule.dslReasonChooser.Buffalo.options.marketingOne.order.std-headline',
                    wording: {
                        headLine: 'revocationModule.dslReasonChooser.Buffalo.options.marketingOne.std-headline',
                        subHeadLine: 'revocationModule.dslReasonChooser.Buffalo.options.marketingOne.std-subHeadline',
                        icon: 'revocationModule.dslReasonChooser.Buffalo.options.marketingOne.opt-icon',
                    },
                },
                {
                    id: 'marketing-Two',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'revocationModule.dslReasonChooser.Buffalo.options.marketingTwo.isHidden.text-body',
                    order: 'revocationModule.dslReasonChooser.Buffalo.options.marketingTwo.order.std-headline',
                    wording: {
                        headLine: 'revocationModule.dslReasonChooser.Buffalo.options.marketingTwo.std-headline',
                        subHeadLine: 'revocationModule.dslReasonChooser.Buffalo.options.marketingTwo.std-subHeadline',
                        icon: 'revocationModule.dslReasonChooser.Buffalo.options.marketingTwo.opt-icon',
                    },
                },
                {
                    id: 'marketing-three',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: OverlayActionType.TOGGLE_OVERLAY,
                    },
                    isHidden: 'revocationModule.dslReasonChooser.Buffalo.options.marketingThree.isHidden.text-body',
                    order: 'revocationModule.dslReasonChooser.Buffalo.options.marketingThree.order.std-headline',
                    wording: {
                        headLine: 'revocationModule.dslReasonChooser.Buffalo.options.marketingThree.std-headline',
                        subHeadLine: 'revocationModule.dslReasonChooser.Buffalo.options.marketingThree.std-subHeadline',
                        icon: 'revocationModule.dslReasonChooser.Buffalo.options.marketingThree.opt-icon',
                    },
                },
                {
                    id: 'other-reason',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'revocationModule.dslReasonChooser.Buffalo.options.otherReason.isHidden.text-body',
                    order: 'revocationModule.dslReasonChooser.Buffalo.options.otherReason.order.std-headline',
                    wording: {
                        headLine: 'revocationModule.dslReasonChooser.Buffalo.options.otherReason.std-headline',
                        subHeadLine: 'revocationModule.dslReasonChooser.Buffalo.options.otherReason.std-subHeadline',
                        icon: 'revocationModule.dslReasonChooser.Buffalo.options.otherReason.opt-icon',
                    },
                },
            ],
        },
        'revocation-dslsalesagent-without-login': {
            steps: [
                {
                    id: 'call-us',
                    hideOnMobile: true,
                    cursorAuto: true,
                    isHidden:'UmCableSalesAgentPage.Buffalo.links.callUs.isHidden.text-body',
                    wording: {
                        headLine:'UmCableSalesAgentPage.Buffalo.links.callUs.number.std-headline',
                        subHeadLine:'UmCableSalesAgentPage.Buffalo.links.callUs.text-body',
                        icon: 'UmCableSalesAgentPage.Buffalo.links.callUs.opt-icon',
                    },
                },
                {
                    id: 'chat-us',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: RoutingActionType.START_ROUTING,
                    },
                    isHidden:'UmCableSalesAgentPage.Buffalo.links.chat-us.isHidden.text-body',
                    wording: {
                        headLine:'UmCableSalesAgentPage.Buffalo.links.chat-us.std-headline',
                        subHeadLine:'UmCableSalesAgentPage.Buffalo.links.chat-us.text-body',
                            icon: 'UmCableSalesAgentPage.Buffalo.links.chat-us.opt-icon',
                    },
                },
                {
                    id: 'our-recall',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: RoutingActionType.START_ROUTING,
                    },
                    isHidden:'UmCableSalesAgentPage.Buffalo.links.our-recall.isHidden.text-body',
                    wording: {
                        headLine:'UmCableSalesAgentPage.Buffalo.links.our-recall.std-headline',
                        subHeadLine:'UmCableSalesAgentPage.Buffalo.links.our-recall.text-body',
                        icon: 'UmCableSalesAgentPage.Buffalo.links.our-recall.opt-icon',
                    },
                },
                {
                    id: 'cancel-now',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: RoutingActionType.START_ROUTING,
                    },
                    isHidden:'UmCableSalesAgentPage.Buffalo.links.cancel-now.isHidden.text-body',
                    wording: {
                        headLine:'UmCableSalesAgentPage.Buffalo.links.cancel-now.std-headline',
                        subHeadLine:'UmCableSalesAgentPage.Buffalo.links.cancel-now.text-body',
                        icon: 'UmCableSalesAgentPage.Buffalo.links.cancel-now.opt-icon',
                    },
                },
            ],
        },
    },
    Python: {
        'dsl-reason-chooser': {
            steps: [
                {
                    id: 'technical-problems',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'revocationModule.dslReasonChooser.Python.options.technicalProblem.isHidden.text-body',
                    order: 'revocationModule.dslReasonChooser.Python.options.technicalProblem.order.std-headline',
                    wording: {
                        headLine: 'revocationModule.dslReasonChooser.Python.options.technicalProblem.std-headline',
                        subHeadLine: 'revocationModule.dslReasonChooser.Python.options.technicalProblem.std-subHeadline',
                        icon: 'revocationModule.dslReasonChooser.Python.options.technicalProblem.opt-icon',
                    },
                },
                {
                    id: 'tariff-problems',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'revocationModule.dslReasonChooser.Python.options.tariffProblem.isHidden.text-body',
                    order: 'revocationModule.dslReasonChooser.Python.options.tariffProblem.order.std-headline',
                    wording: {
                        headLine: 'revocationModule.dslReasonChooser.Python.options.tariffProblem.std-headline',
                        subHeadLine: 'revocationModule.dslReasonChooser.Python.options.tariffProblem.std-subHeadline',
                        icon: 'revocationModule.dslReasonChooser.Python.options.tariffProblem.opt-icon',
                    },
                },
                {
                    id: 'have-questions',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'revocationModule.dslReasonChooser.Python.options.haveQuestions.isHidden.text-body',
                    order: 'revocationModule.dslReasonChooser.Python.options.haveQuestions.order.std-headline',
                    wording: {
                        headLine: 'revocationModule.dslReasonChooser.Python.options.haveQuestions.std-headline',
                        subHeadLine: 'revocationModule.dslReasonChooser.Python.options.haveQuestions.std-subHeadline',
                        icon: 'revocationModule.dslReasonChooser.Python.options.haveQuestions.opt-icon',
                    },
                },
                {
                    id: 'marketing-one',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'revocationModule.dslReasonChooser.Python.options.marketingOne.isHidden.text-body',
                    order: 'revocationModule.dslReasonChooser.Python.options.marketingOne.order.std-headline',
                    wording: {
                        headLine: 'revocationModule.dslReasonChooser.Python.options.marketingOne.std-headline',
                        subHeadLine: 'revocationModule.dslReasonChooser.Python.options.marketingOne.std-subHeadline',
                        icon: 'revocationModule.dslReasonChooser.Python.options.marketingOne.opt-icon',
                    },
                },
                {
                    id: 'marketing-Two',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'revocationModule.dslReasonChooser.Python.options.marketingTwo.isHidden.text-body',
                    order: 'revocationModule.dslReasonChooser.Python.options.marketingTwo.order.std-headline',
                    wording: {
                        headLine: 'revocationModule.dslReasonChooser.Python.options.marketingTwo.std-headline',
                        subHeadLine: 'revocationModule.dslReasonChooser.Python.options.marketingTwo.std-subHeadline',
                        icon: 'revocationModule.dslReasonChooser.Python.options.marketingTwo.opt-icon',
                    },
                },
                {
                    id: 'marketing-three',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: OverlayActionType.TOGGLE_OVERLAY,
                    },
                    isHidden: 'revocationModule.dslReasonChooser.Python.options.marketingThree.isHidden.text-body',
                    order: 'revocationModule.dslReasonChooser.Python.options.marketingThree.order.std-headline',
                    wording: {
                        headLine: 'revocationModule.dslReasonChooser.Python.options.marketingThree.std-headline',
                        subHeadLine: 'revocationModule.dslReasonChooser.Python.options.marketingThree.std-subHeadline',
                        icon: 'revocationModule.dslReasonChooser.Python.options.marketingThree.opt-icon',
                    },
                },
                {
                    id: 'other-reason',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'revocationModule.dslReasonChooser.Python.options.otherReason.isHidden.text-body',
                    order: 'revocationModule.dslReasonChooser.Python.options.otherReason.order.std-headline',
                    wording: {
                        headLine: 'revocationModule.dslReasonChooser.Python.options.otherReason.std-headline',
                        subHeadLine: 'revocationModule.dslReasonChooser.Python.options.otherReason.std-subHeadline',
                        icon: 'revocationModule.dslReasonChooser.Python.options.otherReason.opt-icon',
                    },
                },
            ],
        },
        'revocation-dslsalesagent-with-login': {
            steps: [
                {
                    id: 'call-us',
                    hideOnMobile: true,
                    cursorAuto: true,
                    isHidden:'UmCableSalesAgentPage.Python.links.callUs.isHidden.text-body',
                    wording: {
                        headLine:'UmCableSalesAgentPage.Python.links.callUs.number.std-headline',
                        subHeadLine:'UmCableSalesAgentPage.Python.links.callUs.text-body',
                        icon: 'UmCableSalesAgentPage.Python.links.callUs.opt-icon',
                    },
                },
                {
                    id: 'chat-us',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: RoutingActionType.START_ROUTING,
                    },
                    isHidden:'UmCableSalesAgentPage.Python.links.chat-us.isHidden.text-body',
                    wording: {
                        headLine:'UmCableSalesAgentPage.Python.links.chat-us.std-headline',
                        subHeadLine:'UmCableSalesAgentPage.Python.links.chat-us.text-body',
                            icon: 'UmCableSalesAgentPage.Python.links.chat-us.opt-icon',
                    },
                },
                {
                    id: 'our-recall',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: RoutingActionType.START_ROUTING,
                    },
                    isHidden:'UmCableSalesAgentPage.Python.links.our-recall.isHidden.text-body',
                    wording: {
                        headLine:'UmCableSalesAgentPage.Python.links.our-recall.std-headline',
                        subHeadLine:'UmCableSalesAgentPage.Python.links.our-recall.text-body',
                        icon: 'UmCableSalesAgentPage.Python.links.our-recall.opt-icon',
                    },
                },
                {
                    id: 'cancel-now',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: RoutingActionType.START_ROUTING,
                    },
                    isHidden:'UmCableSalesAgentPage.Python.links.cancel-now.isHidden.text-body',
                    wording: {
                        headLine:'UmCableSalesAgentPage.Python.links.cancel-now.std-headline',
                        subHeadLine:'UmCableSalesAgentPage.Python.links.cancel-now.text-body',
                        icon: 'UmCableSalesAgentPage.Python.links.cancel-now.opt-icon',
                    },
                },
            ],
        },
    },
    Cobra: {
        'dsl-reason-chooser': {
            steps: [
                {
                    id: 'technical-problems',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'revocationModule.dslReasonChooser.Cobra.options.technicalProblem.isHidden.text-body',
                    order: 'revocationModule.dslReasonChooser.Cobra.options.technicalProblem.order.std-headline',
                    wording: {
                        headLine: 'revocationModule.dslReasonChooser.Cobra.options.technicalProblem.std-headline',
                        subHeadLine: 'revocationModule.dslReasonChooser.Cobra.options.technicalProblem.std-subHeadline',
                        icon: 'revocationModule.dslReasonChooser.Cobra.options.technicalProblem.opt-icon',
                    },
                },
                {
                    id: 'tariff-problems',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'revocationModule.dslReasonChooser.Cobra.options.tariffProblem.isHidden.text-body',
                    order: 'revocationModule.dslReasonChooser.Cobra.options.tariffProblem.order.std-headline',
                    wording: {
                        headLine: 'revocationModule.dslReasonChooser.Cobra.options.tariffProblem.std-headline',
                        subHeadLine: 'revocationModule.dslReasonChooser.Cobra.options.tariffProblem.std-subHeadline',
                        icon: 'revocationModule.dslReasonChooser.Cobra.options.tariffProblem.opt-icon',
                    },
                },
                {
                    id: 'have-questions',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'revocationModule.dslReasonChooser.Cobra.options.haveQuestions.isHidden.text-body',
                    order: 'revocationModule.dslReasonChooser.Cobra.options.haveQuestions.order.std-headline',
                    wording: {
                        headLine: 'revocationModule.dslReasonChooser.Cobra.options.haveQuestions.std-headline',
                        subHeadLine: 'revocationModule.dslReasonChooser.Cobra.options.haveQuestions.std-subHeadline',
                        icon: 'revocationModule.dslReasonChooser.Cobra.options.haveQuestions.opt-icon',
                    },
                },
                {
                    id: 'marketing-one',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'revocationModule.dslReasonChooser.Cobra.options.marketingOne.isHidden.text-body',
                    order: 'revocationModule.dslReasonChooser.Cobra.options.marketingOne.order.std-headline',
                    wording: {
                        headLine: 'revocationModule.dslReasonChooser.Cobra.options.marketingOne.std-headline',
                        subHeadLine: 'revocationModule.dslReasonChooser.Cobra.options.marketingOne.std-subHeadline',
                        icon: 'revocationModule.dslReasonChooser.Cobra.options.marketingOne.opt-icon',
                    },
                },
                {
                    id: 'marketing-Two',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'revocationModule.dslReasonChooser.Cobra.options.marketingTwo.isHidden.text-body',
                    order: 'revocationModule.dslReasonChooser.Cobra.options.marketingTwo.order.std-headline',
                    wording: {
                        headLine: 'revocationModule.dslReasonChooser.Cobra.options.marketingTwo.std-headline',
                        subHeadLine: 'revocationModule.dslReasonChooser.Cobra.options.marketingTwo.std-subHeadline',
                        icon: 'revocationModule.dslReasonChooser.Cobra.options.marketingTwo.opt-icon',
                    },
                },
                {
                    id: 'marketing-three',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: OverlayActionType.TOGGLE_OVERLAY,
                    },
                    isHidden: 'revocationModule.dslReasonChooser.Cobra.options.marketingThree.isHidden.text-body',
                    order: 'revocationModule.dslReasonChooser.Cobra.options.marketingThree.order.std-headline',
                    wording: {
                        headLine: 'revocationModule.dslReasonChooser.Cobra.options.marketingThree.std-headline',
                        subHeadLine: 'revocationModule.dslReasonChooser.Cobra.options.marketingThree.std-subHeadline',
                        icon: 'revocationModule.dslReasonChooser.Cobra.options.marketingThree.opt-icon',
                    },
                },
                {
                    id: 'other-reason',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'revocationModule.dslReasonChooser.Cobra.options.otherReason.isHidden.text-body',
                    order: 'revocationModule.dslReasonChooser.Cobra.options.otherReason.order.std-headline',
                    wording: {
                        headLine: 'revocationModule.dslReasonChooser.Cobra.options.otherReason.std-headline',
                        subHeadLine: 'revocationModule.dslReasonChooser.Cobra.options.otherReason.std-subHeadline',
                        icon: 'revocationModule.dslReasonChooser.Cobra.options.otherReason.opt-icon',
                    },
                },
            ],
        },
        'revocation-dslsalesagent-with-login': {
            steps: [
                {
                    id: 'call-us',
                    hideOnMobile: true,
                    cursorAuto: true,
                    isHidden:'UmCableSalesAgentPage.Cobra.links.callUs.isHidden.text-body',
                    wording: {
                        headLine:'UmCableSalesAgentPage.Cobra.links.callUs.number.std-headline',
                        subHeadLine:'UmCableSalesAgentPage.Cobra.links.callUs.text-body',
                        icon: 'UmCableSalesAgentPage.Cobra.links.callUs.opt-icon',
                    },
                },
                {
                    id: 'chat-us',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: RoutingActionType.START_ROUTING,
                    },
                    isHidden:'UmCableSalesAgentPage.Cobra.links.chat-us.isHidden.text-body',
                    wording: {
                        headLine:'UmCableSalesAgentPage.Cobra.links.chat-us.std-headline',
                        subHeadLine:'UmCableSalesAgentPage.Cobra.links.chat-us.text-body',
                            icon: 'UmCableSalesAgentPage.Cobra.links.chat-us.opt-icon',
                    },
                },
                {
                    id: 'our-recall',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: RoutingActionType.START_ROUTING,
                    },
                    isHidden:'UmCableSalesAgentPage.Cobra.links.our-recall.isHidden.text-body',
                    wording: {
                        headLine:'UmCableSalesAgentPage.Cobra.links.our-recall.std-headline',
                        subHeadLine:'UmCableSalesAgentPage.Cobra.links.our-recall.text-body',
                        icon: 'UmCableSalesAgentPage.Cobra.links.our-recall.opt-icon',
                    },
                },
                {
                    id: 'cancel-now',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: RoutingActionType.START_ROUTING,
                    },
                    isHidden:'UmCableSalesAgentPage.Cobra.links.cancel-now.isHidden.text-body',
                    wording: {
                        headLine:'UmCableSalesAgentPage.Cobra.links.cancel-now.std-headline',
                        subHeadLine:'UmCableSalesAgentPage.Cobra.links.cancel-now.text-body',
                        icon: 'UmCableSalesAgentPage.Cobra.links.cancel-now.opt-icon',
                    },
                },
            ],
        },
    },
    Moose: {
        'dsl-reason-chooser': {
            steps: [
                {
                    id: 'moved',
                    type: ACTION_TYPE.NAVIGATION_ACTION,
                    linkDetails: {
                        routeURL: 'terminationModule.dslReasonChooser.Moose.options.moved.link-href',
                        isExternal: true,
                        target: '_blank',
                    },
                    isHidden: 'terminationModule.dslReasonChooser.Moose.options.moved.isHidden.text-body',
                    order: 'terminationModule.dslReasonChooser.Moose.options.moved.order.std-headline',
                    wording: {
                        headLine: 'terminationModule.dslReasonChooser.Moose.options.moved.std-headline',
                        subHeadLine: 'terminationModule.dslReasonChooser.Moose.options.moved.std-subHeadline',
                        icon: 'terminationModule.dslReasonChooser.Moose.options.moved.opt-icon',
                    },
                },
                {
                    id: 'there-a-death',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'terminationModule.dslReasonChooser.Moose.options.thereDeath.isHidden.text-body',
                    order: 'terminationModule.dslReasonChooser.Moose.options.thereDeath.order.std-headline',
                    wording: {
                        headLine: 'terminationModule.dslReasonChooser.Moose.options.thereDeath.std-headline',
                        subHeadLine: 'terminationModule.dslReasonChooser.Moose.options.thereDeath.std-subHeadline',
                        icon: 'terminationModule.dslReasonChooser.Moose.options.thereDeath.opt-icon',
                    },
                },
                {
                    id: 'have-questions',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'terminationModule.dslReasonChooser.Moose.options.haveQuestions.isHidden.text-body',
                    order: 'terminationModule.dslReasonChooser.Moose.options.haveQuestions.order.std-headline',
                    wording: {
                        headLine: 'terminationModule.dslReasonChooser.Moose.options.haveQuestions.std-headline',
                        subHeadLine: 'terminationModule.dslReasonChooser.Moose.options.haveQuestions.std-subHeadline',
                        icon: 'terminationModule.dslReasonChooser.Moose.options.haveQuestions.opt-icon',
                    },
                },
                {
                    id: 'marketing-one',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'terminationModule.dslReasonChooser.Moose.options.marketingOne.isHidden.text-body',
                    order: 'terminationModule.dslReasonChooser.Moose.options.marketingOne.order.std-headline',
                    wording: {
                        headLine: 'terminationModule.dslReasonChooser.Moose.options.marketingOne.std-headline',
                        subHeadLine: 'terminationModule.dslReasonChooser.Moose.options.marketingOne.std-subHeadline',
                        icon: 'terminationModule.dslReasonChooser.Moose.options.marketingOne.opt-icon',
                    },
                },
                {
                    id: 'marketing-two',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'terminationModule.dslReasonChooser.Moose.options.marketingTwo.isHidden.text-body',
                    order: 'terminationModule.dslReasonChooser.Moose.options.marketingTwo.order.std-headline',
                    wording: {
                        headLine: 'terminationModule.dslReasonChooser.Moose.options.marketingTwo.std-headline',
                        subHeadLine: 'terminationModule.dslReasonChooser.Moose.options.marketingTwo.std-subHeadline',
                        icon: 'terminationModule.dslReasonChooser.Moose.options.marketingTwo.opt-icon',
                    },
                },
                {
                    id: 'marketing-three',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: OverlayActionType.TOGGLE_OVERLAY,
                    },
                    isHidden: 'terminationModule.dslReasonChooser.Moose.options.marketingThree.isHidden.text-body',
                    order: 'terminationModule.dslReasonChooser.Moose.options.marketingThree.order.std-headline',
                    wording: {
                        headLine: 'terminationModule.dslReasonChooser.Moose.options.marketingThree.std-headline',
                        subHeadLine: 'terminationModule.dslReasonChooser.Moose.options.marketingThree.std-subHeadline',
                        icon: 'terminationModule.dslReasonChooser.Moose.options.marketingThree.opt-icon',
                    },
                },
                {
                    id: 'other-reason',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: CustomerDetailsActionTypes.CHOSSE_REASON + ',' + RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'terminationModule.dslReasonChooser.Moose.options.otherReason.isHidden.text-body',
                    order: 'terminationModule.dslReasonChooser.Moose.options.otherReason.order.std-headline',
                    wording: {
                        headLine: 'terminationModule.dslReasonChooser.Moose.options.otherReason.std-headline',
                        subHeadLine: 'terminationModule.dslReasonChooser.Moose.options.otherReason.std-subHeadline',
                        icon: 'terminationModule.dslReasonChooser.Moose.options.otherReason.opt-icon',
                    },
                },
            ],
        },
        'termination-salesagentdsl-without-login': {
            steps: [
                {
                    id: 'call-us',
                    hideOnMobile: true,
                    cursorAuto: true,
                    isHidden: 'UmCableSalesAgentPage.Moose.links.callUs.isHidden.text-body',
                    wording: {
                        headLine:
                            'UmCableSalesAgentPage.Moose.links.callUs.number.std-headline',
                        subHeadLine:
                            'UmCableSalesAgentPage.Moose.links.callUs.text-body',
                        icon: 'UmCableSalesAgentPage.Moose.links.callUs.opt-icon',
                    },
                },
                {
                    id: 'chat-us',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: RoutingActionType.START_ROUTING,
                    },
                    isHidden:'UmCableSalesAgentPage.Moose.links.chat-us.isHidden.text-body',
                    wording: {
                        headLine:
                            'UmCableSalesAgentPage.Moose.links.chat-us.std-headline',
                        subHeadLine:
                            'UmCableSalesAgentPage.Moose.links.chat-us.text-body',
                        icon: 'UmCableSalesAgentPage.Moose.links.chat-us.opt-icon',
                    },
                },
                {
                    id: 'our-recall',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: RoutingActionType.START_ROUTING,
                    },
                    isHidden:'UmCableSalesAgentPage.Moose.links.our-recall.isHidden.text-body',
                    wording: {
                        headLine:
                            'UmCableSalesAgentPage.Moose.links.our-recall.std-headline',
                        subHeadLine:
                            'UmCableSalesAgentPage.Moose.links.our-recall.text-body',
                        icon: 'UmCableSalesAgentPage.Moose.links.our-recall.opt-icon',
                    },
                },
                {
                    id: 'cancel-now',
                    type: ACTION_TYPE.REDUX_ACTION,
                    actionDetails: {
                        dispatchAction: RoutingActionType.START_ROUTING,
                    },
                    isHidden: 'UmCableSalesAgentPage.Moose.links.cancel-now.isHidden.text-body',
                    wording: {
                        headLine:
                            'UmCableSalesAgentPage.Moose.links.cancel-now.std-headline',
                        subHeadLine:
                            'UmCableSalesAgentPage.Moose.links.cancel-now.text-body',
                        icon: 'UmCableSalesAgentPage.Moose.links.cancel-now.opt-icon',
                    },
                },
            ],
        },
    },

};
